import React from 'react';
import {
  waitingStatusDetail,
  waitingStatusClasses,
} from '../../../data/statusDefinitions';
import QuoteElementExpertAcceptationModal from './QuoteElementExpertAcceptationModal/QuoteElementExpertAcceptationModal';
import QuoteElementExpertPrestationModal from './QuoteElementExpertPrestationModal/QuoteElementExpertPrestationModal';
import { formatDate } from '../../../utils/date';
import ClientInformations from './ClientInformations';
import QuoteElementExpertPaiementModal from './QuoteElementExpertPaiementModal/QuoteElementExpertPaiementModal';
import { quoteStatus } from '../../../data/quoteStatus';
import ClientDetails from './ClientDetails';
import { addTransition } from '../../../utils/accordeon';
import ClientDocuments from './ClientDocuments';

function QuoteElementExpert(props) {
  function showDetails() {
    let elm = document.getElementById(props.clientExpertRelation.id);

    if (elm.classList.contains('active')) {
      elm.getElementsByClassName('element-details-open')[0].style.maxHeight =
        '0px';
      elm.classList.remove('active');
    } else {
      elm.classList.add('active');
      const tabElm = elm.getElementsByClassName('element-details-open')[0];
      addTransition(elm, tabElm, 50, 400);
    }
  }

  function getContainerClasses() {
    if ([2, 3, 4].includes(props?.clientExpertRelation?.status))
      return 'element-container container-wrap';

    return 'element-container';
  }

  function processStatus() {
    let status = props?.clientExpertRelation?.status;

    if (
      props?.clientExpertRelation?.status === 3 &&
      props?.clientExpertRelation?.expertSigned
    )
      status++;

    return status;
  }

  return (
    <div className={getContainerClasses()} id={props.clientExpertRelation.id}>
      <div className="elements-data">
        {processStatus() >= quoteStatus.clientAcceptAppointment && (
          <div className="element-demand">
            <span className="data-title">Nom client</span>
            <span className="data">{`${props?.clientExpertRelation?.client?.firstName} ${props?.clientExpertRelation?.client?.lastName}`}</span>
          </div>
        )}
        <div className="element-demand">
          <span className="data-title">Numéro client</span>
          <span className="data">{`#${props?.clientExpertRelation?.referenceNumber}`}</span>
        </div>
        {processStatus() >= quoteStatus.clientAcceptAppointment && (
          <div className="element-demand">
            <span className="data-title">Date rendez-vous</span>
            <span className="data">
              {props?.appointment?.appointmentDate !== undefined
                ? `${formatDate(
                    props?.appointment?.appointmentDate,
                    'DD.MM.YYYY'
                  )}-${formatDate(
                    props?.appointment?.appointmentDate,
                    'HH[h]mm'
                  )}`
                : 'Aucune'}
            </span>
          </div>
        )}
        <div className="element-demand element-amount">
          <span className="data-title">Montant estimé</span>
          <span className="data">
            {props?.clientExpertRelation?.quote?.price === 0
              ? 'À déterminer lors du rendez-vous'
              : `${props?.clientExpertRelation?.quote?.price}€ à l'année`}
          </span>
        </div>
        {/* {processStatus() === quoteStatus.signed && (
					<div className="element-demand">
						<span className="data-title">Date signature</span>
						<span className="data">25.06.2023</span>
					</div>
				)} */}
        <div className="element-demand element-status">
          <span className="data-title">Statut</span>
          {
            <span
              className={`status-demand ${
                waitingStatusClasses[processStatus()]
              }`}
            >
              {waitingStatusDetail.expert[processStatus()]}
            </span>
          }
        </div>
        {[0, 1, 2, 3, 4, 5].includes(processStatus()) && (
          <div className="detail-icon" onClick={(e) => showDetails(e)}></div>
        )}
      </div>
      <div className="element-details-open">
        {[2, 3, 4, 5].includes(processStatus()) && (
          <ClientInformations
            clientExpertRelation={props?.clientExpertRelation}
            client={props?.client}
          />
        )}
        {[0, 1, 2, 3, 4].includes(processStatus()) && (
          <div className="container-client-details">
            <ClientDetails client={props?.client} />
          </div>
        )}
        {[2, 3, 4].includes(processStatus()) && (
          <ClientDocuments
            id={props.clientExpertRelation.id}
            documents={props?.client?.documents}
          />
        )}
        {processStatus() === quoteStatus.clientChoseExpert && (
          <QuoteElementExpertAcceptationModal
            clientExpertRelation={props?.clientExpertRelation}
            client={props?.client}
          />
        )}
        {processStatus() === quoteStatus.appointmentAchieved && (
          <QuoteElementExpertPrestationModal
            clientExpertRelation={props?.clientExpertRelation}
            client={props?.client}
          />
        )}
        {processStatus() === quoteStatus.signed && (
          <QuoteElementExpertPaiementModal
            clientExpertRelation={props?.clientExpertRelation}
            client={props?.client}
            showDetails={() => showDetails()}
          />
        )}
      </div>
    </div>
  );
}

export default QuoteElementExpert;
